import Data from "../assets/scripts/base/Data"
import { setState } from "@/store"

const ROOT = ""

export const METHOD = {
	GET: "GET",
	POST: "POST",
	PUT: "PUT",
	DELETE: "DELETE"
}

export const create = options => {
	let service = {};
	const isArray = Array.isArray(options);
	if (Array.isArray(options)) options.forEach(createHandler)
	else return createHandler(options)
	function createHandler(item) {
		let { name, url, method, root } = item;
		url = ROOT + (root ? root + url : url);

		const fn = {
			GET: (params) => {
				return new Promise((resolve) => {
					setState("fetchLoading", true);
					Data.get({ url, params }).then((res) => {
						setState("fetchLoading", false);
						resolve(res);
					}).catch(() => {
						setState("fetchLoading", false);
						resolve({
							data: {
								msg: "服务器异常",
								status: 0
							}
						})
					})
				})
			},
			POST: (params) => {
				return new Promise((resolve) => {
					setState("fetchLoading", true);
					Data.post({ url, params }).then((res) => {
						setState("fetchLoading", false);
						resolve(res);
					}).catch(() => {
						setState("fetchLoading", false);
						resolve({
							data: {
								msg: "服务器异常",
								status: 0
							}
						})
					})
				})
			},
			DELETE: (params) => {
				return new Promise((resolve) => {
					setState("fetchLoading", true);
					Data.delete({ url, params }).then((res) => {
						setState("fetchLoading", false);
						resolve(res);
					}).catch((err) => {
						console.error(err);
						setState("fetchLoading", false);
						resolve({
							data: {
								msg: "服务器异常",
								status: 0
							}
						})
					})
				})
			},
			PUT: (params) => {
				return new Promise((resolve) => {
					setState("fetchLoading", true);
					Data.put({ url, params }).then((res) => {
						setState("fetchLoading", false);
						resolve(res);
					}).catch(() => {
						setState("fetchLoading", false);
						resolve({
							data: {
								msg: "服务器异常",
								status: 0
							}
						})
					})
				})
			},
		}[method]

		// const fn = (method => (params) => {
		// 	return new Promise((resolve) => {
		// 		setState("fetchLoading", true);
		// 		Data[method.toLowerCase()]({ url, params }).then(() => {
		// 			setState("fetchLoading", false);
		// 			resolve(arguments);
		// 		}).catch(() => {
		// 			setState("fetchLoading", false);
		// 			resolve({
		// 				data: {
		// 					msg: "服务器异常",
		// 					status: 0
		// 				}
		// 			})
		// 		})
		// 	})
		// })(method)

		if (!isArray) return fn;
		service[name] = fn;
	}
	return service;
}
